var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.6663H2.66667C2.29848 14.6663 2 14.3679 2 13.9997V1.99967C2 1.63149 2.29848 1.33301 2.66667 1.33301H13.3333C13.7015 1.33301 14 1.63149 14 1.99967V13.9997C14 14.3679 13.7015 14.6663 13.3333 14.6663ZM5.33333 4.66634V5.99967H10.6667V4.66634H5.33333ZM5.33333 7.33301V8.66634H10.6667V7.33301H5.33333ZM5.33333 9.99967V11.333H8.66667V9.99967H5.33333Z",
    fill: "#8CA2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon_document.9fb37a2d1a59119843e29cd2174676ea.svg";
export { ForwardRef as ReactComponent };